import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { Portfolio } from '../components/Portfolio';
export const HomePage = () => {
  useEffect(() => {
    document.title = 'Home | Race Capital';
  }, []);
  return <>
      <Hero data-id="element-250" />
      <Portfolio data-id="element-251" />
    </>;
};